export default function processInterstAreas(formData, candidateData) {
    const interestAreasFromForm = formData.interestAreas;
    const interestAreasBaseObj = {};

    //Load all prev ids
    if(candidateData.interestAreas instanceof Array){
        candidateData.interestAreas.forEach((area) => {
            interestAreasBaseObj[area.interestArea] = area.id;
        });
    }

    //Check instanceof and load ids
    if(interestAreasFromForm instanceof Array){
        interestAreasFromForm.forEach((area) => {
            if(interestAreasBaseObj[area.interestArea]){
                area.id = interestAreasBaseObj[area.interestArea];
            }
        });
    }
    return interestAreasFromForm;
}